export default "__VITE_ASSET__BufOP0E$__"